import React, {useEffect} from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Auth,
} from 'aws-amplify'

import { 
    WhiteDiv, 
    HeaderDiv, 
    ComponentsDiv 
} from '../Styles/BaseStyles'

import NavBar from '../Components/Action/NavBar'
import Blurb from '../Components/Display/Blurb'
import How from '../Components/Display/How'
import PricingContainer from '../Components/Display/PricingContainer'
import TeamContainer from '../Components/Display/TeamContainer'
import Contact from '../Components/Action/Contact'
import Copyright from '../Components/Display/Copyright'
import Disclaimer from '../Components/Display/Disclaimer'

import { useSelector, useDispatch } from 'react-redux'

import { reset as forgotPasswordReset } from '../Redux/Slices/ForgotPasswordSlice'
import { reset as userReset } from '../Redux/Slices/UserSlice'
import { resetHubPage } from '../Redux/Slices/HubSlice'

function Main(props){
    let history = useHistory()
    let dispatch = useDispatch()
    
    const storage = useSelector(state => state.user.storage)

    dispatch(forgotPasswordReset())
    dispatch(resetHubPage())

    useEffect(() => {
        switch(storage){
            case 'localstorage':
                Auth.configure({storage: localStorage})
                break
            case 'sessionstorage':
                Auth.configure({storage: sessionStorage})
                break
            default:
                break
        }
        Auth.currentAuthenticatedUser().then(() => {
            history.push('/hub')
        })
        .catch(() => {
            dispatch(userReset())
        })
    }, [])

    return (
        <>
            <HeaderDiv>
                <WhiteDiv>
                    <NavBar page="Main"/>
                </WhiteDiv>
            </HeaderDiv>
            <ComponentsDiv>
                <Disclaimer />
                <Blurb />
                <How />
                <PricingContainer />
                <TeamContainer />
                <Contact />
                <Copyright />
            </ComponentsDiv>
        </>
    )
}

export default Main